export const FirebaseCollections = {
  APP_SETTINGS: 'AppSettings',
  KIOSK_SETTINGS: 'KioskSettings',
  EARLY_CHECK_IN_PROCESS: 'EarlyCheckInProcess',
  EXPIRATION_BOUND_ENTITY: 'ExpirationBoundEntity',
  PHONE_PREFIXES: 'PhonePrefixes',
  TAFNIT_COUNTRIES: 'TafnitCountries',
  TAFNIT_STATES: 'TafnitStates',
} as const;
